import { NEXT_PUBLIC_IMAGE_URL } from '@/common';
import type { Metadata } from 'next';

export const SITE_URL = new URL('https://www.upzi.vn');
export const SITE_NAME = 'Upzi';
export const SITE_DEFAULT_TITLE =
  'Upzi - Người bạn thông minh cho sự nghiệp Gen Z';
export const SITE_DESCRIPTION =
  'Upzi đồng hành cùng Gen Z khám phá cơ hội việc làm, tạo CV và phát triển sự nghiệp.';
export const SITE_OG_IMAGE_URL = `${NEXT_PUBLIC_IMAGE_URL}/image/upzi/thumbnail/thumbnail_cv_builder.jpg`;
export const SITE_OG_JOB_IMAGE_URL = `${NEXT_PUBLIC_IMAGE_URL}/image/upzi/thumbnail/thumbnail_tim_viec.jpg`;

export function getAbsoluteUrl(path = '/') {
  return new URL(path, SITE_URL).toString();
}

export const siteMetadata: Metadata = {
  metadataBase: SITE_URL,
  title: {
    default: SITE_DEFAULT_TITLE,
    template: '%s | Upzi',
  },
  description: SITE_DESCRIPTION,
  keywords: [
    'Upzi',
    'tạo CV',
    'CV chuyên nghiệp',
    'AI hỗ trợ',
    'việc làm Gen Z',
    'sự nghiệp',
    'tuyển dụng',
    'phát triển kỹ năng',
  ],
  authors: [{ name: 'Upzi Team' }],
  creator: SITE_NAME,
  publisher: SITE_NAME,
  verification: {
    google: 'oN-vjDie6GknFKJXYGcuPRsm-a_3uJSwdJPdyg2TFKo',
    other: {
      'msvalidate.01': '70729B28932B159FFB59704FE136A743',
    },
  },
  icons: {
    icon: [
      { url: '/favicon.ico', sizes: 'any' },
      { url: '/favicon-32x32.png', sizes: '32x32', type: 'image/png' },
    ],
    shortcut: '/favicon.ico',
    apple: [
      {
        url: '/apple-touch-icon.png',
        sizes: '180x180',
        type: 'image/png',
      },
    ],
  },
  robots: {
    index: true,
    follow: true,
    googleBot: {
      index: true,
      follow: true,
      'max-video-preview': -1,
      'max-image-preview': 'large',
      'max-snippet': -1,
    },
  },
  openGraph: {
    title: SITE_DEFAULT_TITLE,
    description: SITE_DESCRIPTION,
    url: getAbsoluteUrl(),
    siteName: SITE_NAME,
    locale: 'vi_VN',
    type: 'website',
    images: [
      {
        url: SITE_OG_JOB_IMAGE_URL,
        width: 1200,
        height: 630,
        alt: SITE_DEFAULT_TITLE,
      },
    ],
  },
  twitter: {
    card: 'summary_large_image',
    title: SITE_DEFAULT_TITLE,
    description: SITE_DESCRIPTION,
    images: [SITE_OG_JOB_IMAGE_URL],
    creator: '@upzi_vn',
    site: '@upzi_vn',
  },
  alternates: {
    canonical: getAbsoluteUrl(),
  },
  category: 'Career Development',
};
